const items = [
    {
        roof: ["caramel", "Doce Leite"],
    },
    {
        roof: ["nutella", "Nutella"],
    },
    {
        roof: ["milk", "Leite Cond"],
    },
    {
        roof: ["raspberry", "Framboesa"],
    },
];

export default items;
